import React from 'react';
import FAQList from '../components/setting/FAQList';

const FAQListPage: React.FC = () => {
  return (
    <div className="main-container">
      <FAQList />
    </div>
  );
};

export default FAQListPage;
